/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const refreshInvoiceRegister = (data) => ({
  type: ActionTypes.REFRESH_INVOICE_REGISTER,
  payload: data,
});
export const refreshInvoiceRegisterDisplay = (data) => ({
  type: ActionTypes.REFRESH_INVOICE_REGISTER_DISPLAY,
  payload: data,
});
export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY,
  payload: data,
});

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY,
  isLoading: value,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

//API call to get Max Quarter
export const getInvoiceRegisterMaxQtr = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_INV_REG_MAX_QTR}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MAX_QUARTER_INVOICE_REGISTER,
        zeroUraMaxQuarter: response.data.maxQuarterVO,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};
export const dispatchNoDataMessage = (data) => ({
  type: ActionTypes.NO_DATA_MESSAGE,
  noDataMessage: data,
});

export const setInvoiceRegisterChecked = (data) => ({
  type: ActionTypes.GET_INVOICE_RESULT,
  invoiceResult: data,
});

//API call for the display screen grid for checked
export const getInvoiceResult = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.INVOICE_REGISTER}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.rebateInvoiceRegisterReportVO.length === 0) {
        dispatch(dispatchNoDataMessage(NO_DATA));
      } else {
        let invoiceData = {
          [values.rebateProgramCd]:
            response?.data?.rebateInvoiceRegisterReportVO,
        };
        return dispatch(setInvoiceRegisterChecked(invoiceData));
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setInvoiceRegisterChecked([]));
      return response;
    });
};

export const setInvoiceRegisterUnchecked = (data) => ({
  type: ActionTypes.GET_INVOICE_RESULT_UNCHECKED,
  invoiceResultUnchecked: data,
});

export const getInvoiceResultUnchecked = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.INVOICE_REGISTER_UNCHECKED}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.rebateInvoiceRegisterReportVO.length === 0) {
        dispatch(showNoDataMessage());
        dispatch(dispatchNoDataMessage(NO_DATA));
      } else {
        let invoiceRegisterData = {
          [values.rebateProgramCd]:
            response?.data?.rebateInvoiceRegisterReportVO,
        };
        return dispatch(setInvoiceRegisterUnchecked(invoiceRegisterData));
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setInvoiceRegisterUnchecked([]));
      return response;
    });
};
